export default "__VITE_ASSET__BhfCWcka__"